import React from 'react';
import './NotFound.scss';

import { useRouteError, useNavigate } from 'react-router-dom';

import { Box } from "@mui/material";

import LocalStorageHelper from '../../../Utilities/Helpers/LocalStorageHelper';

import { StaticDisplayText } from '../../../Constants/StaticDisplayTexts';
import { ErrorMessage } from '../../../Constants/Messages';

import { RouteEnum } from '../../../Utilities/Enums/RouteEnums';

import NotFound from './NotFound';

const ErrorPage = () => {
    const error:any = useRouteError();
    const navigate = useNavigate();
    
    if (error && error.status) {

        if (error.status == 404)
            return <NotFound />

        // if (error.status == 401) {
        //     // window.history.replaceState(null, process.env.REACT_APP_NAME, "/");
        //     navigate(RouteEnum.LOGIN, { replace: true });
        //     document.title = StaticDisplayText.APP_NAME;
        //     LocalStorageHelper.clearLocalStorage();

        //     return <></>;
        // }
    }

    return <div className="pageNotFoundContainer">
        <div className="pageNotFoundContent">
            <h2>{ErrorMessage.SOMETHING_WENT_WRONG}</h2>
            <Box className="pageNotFoundText">{ErrorMessage.REFRESH_OR_REPORT}</Box>
        </div>
    </div>;
}

export default ErrorPage;